import { Component } from "@angular/core";

@Component({
  selector: "app-simple-payment-modal",
  templateUrl: "./simple-payment-modal.component.html",
  styleUrls: ["./simple-payment-modal.component.scss"]
})
export class SimplePaymentModalComponent {}
